import React, { useState } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { DF_OT0050Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";
import { fnGetValueByKey } from "../../helpers/functions";
import withRouter from "../../components/Common/withRouter";

const DF_OT0050 = () => {
  console.log("🤖 %cTransação [DF_OT0050]", "color:green");

  const { userProfile, isModalPage } = useSelector((state) => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
  }));

  const [isLoading, setisLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false); 
  const [isOpenModalNuevo, setIsOpenModalNuevo] = useState(false); 
  const [paramsOnFilter, setParamsOnFilter] = useState([]);
  const [triggerOnFilter, setTriggerOnFilter] = useState(false);
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  return (
    <React.Fragment>
      <DF_OT0050Context.Provider
        value={{
          isLoading,
          userProfile,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          isOpenModalNuevo,
          setIsOpenModalNuevo,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData,
        }}
      >
        <div
          style={{
            padding: isModalPage && "0px",
            overflow: isModalPage && "hidden",
          }}
          className="page-content"
        >
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_OT0050Context.Provider>
    </React.Fragment>
  );
};

export default withRouter(DF_OT0050);